export default __webpack_public_path__ + "static/media/hum_normal_light.0ef493fa.svg";